export function preventUnhandledRejection(promise) {
    promise.catch(function () { });
    return promise;
}
//# sourceMappingURL=preventUnhandledRejection.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@apollo/client/utilities/promises/preventUnhandledRejection.js
// module id = 2096
// module chunks = 11